import { ModelBase } from '../abstract/model-base.model';

export class EmailRedirection extends ModelBase {

    static override CLASS_NAME: string = 'EmailRedirection';

    private _active!: boolean;
    private _clientSlug!: string;

    public get active(): boolean {
        return this._active;
    }

    public set active(value: any) {
        this._setValue('_active', value, 'boolean');
    }

    public get clientSlug(): string {
        return this._clientSlug;
    }

    public set clientSlug(value: any) {
        this._setValue('_clientSlug', value, 'string');
    }
}
